/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Dropdown, Icon } from 'semantic-ui-react'
import useUser from '../../Shared/UserProvider/useUser'
import { useTranslation } from 'react-i18next'
import useMediaQuery from 'beautiful-react-hooks/useMediaQuery'
import { Link, useNavigate } from 'react-router-dom-v5-compat'
import { exportProducts } from '../../../services/Product/Product.service'
import { saveFile } from '../../../services/File/File.service'
import { ultyToast } from '../../Shared/UltyToast/UltyToast'
import ProductUploadModal from '../ItemsList/ProductUploadModal'
import { useInvalidateCountAndSearch } from '../useInvalidateCountAndSearch'

const itemLinkStyle = css`
    color: black;
    text-decoration: none;

    &:hover {
        color: black;
    }

    i {
        margin-right: .78571429rem !important;
    }
`

const ManageProducts = () => {
    const {can} = useUser()
    const [t] = useTranslation()
    const isMobile = useMediaQuery(`(max-width: 768px)`)
    const navigate = useNavigate();
    const { invalidateCountAndSearch } = useInvalidateCountAndSearch()

    if (!can('CREATE', 'items')) {
        return null
    }

    const handleExportProducts = async () => {
        try {
            const {data} = await exportProducts()
            saveFile(t('product_list.export.export_products_file_name'), data, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
        } catch (e) {
            console.log(e)
            ultyToast({ type: 'error', title: t('global.anErrorOccurred') })
        }
    }

    return (
      <Dropdown
        css={css`
                        &.ui.dropdown {
                            flex-grow: ${isMobile ? 1 : 0};
                            text-align: center;
                        }
                    `}
        text={t('product_list.manage_products')}
        floating
        button
        basic
        className="icon teal right labeled">
          <Dropdown.Menu className="right">
              <Dropdown.Item onClick={() => navigate('/products/edit')}>
                  <Icon name="plus" color="teal"/>
                  {t('product_list.add_product')}
              </Dropdown.Item>
              <Dropdown.Item>
                  <Link to={`/extras/edit`} css={itemLinkStyle}>
                      <Icon name="plus" color="teal"/>
                      {t('product_list.add_extra')}
                  </Link>
              </Dropdown.Item>
              <Dropdown.Item>
                  <Link to={`/menus/edit`} css={itemLinkStyle}>
                      <Icon name="plus" color="teal"/>
                      {t('product_list.add_menu')}
                  </Link>
              </Dropdown.Item>

              <ProductUploadModal reload={() => {
                  invalidateCountAndSearch();
              }}/>
              <Dropdown.Item onClick={handleExportProducts}>
                  <Icon name="upload" color="teal"/>
                  {t('product_list.export.export_products')}
              </Dropdown.Item>
          </Dropdown.Menu>
      </Dropdown>
    )
}

export { ManageProducts }
